var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _rect2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckoutNotPossible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 109,
    viewBox: "0 0 187 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3243 59.9949C84.3791 60.9401 84.4053 66.9526 84.5366 69.8407L172.755 70.6283C172.624 67.4777 172.125 60.94 171.18 59.9948C170.235 59.0496 167.11 59.0759 165.666 59.2072C139.279 59.076 86.2695 59.0497 85.3243 59.9949Z",
    fill: "var(--error-background-color, #FEEDEB)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4751 23.1547C88.4751 19.7925 91.2007 17.0669 94.5629 17.0669H163.517C166.879 17.0669 169.605 19.7925 169.605 23.1547V58.8133H88.4751V23.1547Z",
    fill: "var(--error-background-color, #FEEDEB)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.176,
    y: 78.7515,
    width: 115.839,
    height: 10.9499,
    rx: 5.47497,
    fill: "var(--primary-text-color, #313639)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.291 62.3592L122.876 58.5947C122.626 58.4831 122.353 58.4321 122.08 58.446C121.807 58.4599 121.54 58.5382 121.303 58.6746L117.577 60.8173C117.318 60.9656 117.102 61.1779 116.949 61.4339C116.797 61.6898 116.713 61.9808 116.705 62.2787C116.697 62.5766 116.766 62.8715 116.906 63.135C117.045 63.3985 117.25 63.6217 117.5 63.7831L130.2 71.9789C130.432 72.1282 130.696 72.2202 130.97 72.2473C131.244 72.2745 131.521 72.2361 131.777 72.1352L146.71 66.2314L141.671 79.317C141.543 79.647 141.518 80.0084 141.601 80.3527C141.684 80.6969 141.871 81.0076 142.135 81.243C142.4 81.4784 142.73 81.6274 143.081 81.6698C143.433 81.7123 143.789 81.6462 144.102 81.4805L147.46 79.7441C147.764 79.5886 148.015 79.347 148.183 79.0495L157.559 61.9355L169.547 56.6395C170.633 56.184 171.493 55.316 171.938 54.2265C172.384 53.1369 172.378 51.9149 171.923 50.8295C171.467 49.744 170.599 48.884 169.51 48.4385C168.42 47.993 167.198 47.9986 166.113 48.4541L131.291 62.3592Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.343 53.5558L140.052 45.2211C139.795 45.0574 139.499 44.9645 139.194 44.9517C138.889 44.9389 138.586 45.0067 138.316 45.1481L134.753 46.9887C134.484 47.1272 134.255 47.3336 134.091 47.5875C133.926 47.8413 133.83 48.1339 133.813 48.4361C133.797 48.7382 133.859 49.0396 133.995 49.3102C134.13 49.5808 134.334 49.8113 134.586 49.9788L144.966 56.8828",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.43 55.3096C108.599 54.3284 104.147 51.9967 100.589 48.5854C97.0308 45.1741 94.5139 40.8233 93.3305 36.0384C92.147 31.2536 92.3456 26.2311 93.9031 21.5546C95.4606 16.8781 98.3132 12.7396 102.129 9.61982C105.945 6.50006 110.568 4.52718 115.461 3.9304C120.354 3.33361 125.316 4.13742 129.77 6.24844C134.224 8.35946 137.988 11.691 140.623 15.856C143.259 20.021 144.659 24.8485 144.661 29.7775",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.39 50.1317L104.724 38.4596H107.224C107.752 38.4595 108.272 38.3391 108.747 38.1078C109.221 37.8764 109.636 37.5401 109.96 37.1244C110.285 36.7086 110.511 36.2244 110.62 35.7084C110.73 35.1924 110.721 34.6582 110.593 34.1464L108.857 27.2007C108.669 26.4491 108.236 25.7818 107.625 25.3048C107.015 24.8278 106.263 24.5686 105.488 24.5684H93.0935",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.417 14.1499H130.009C129.235 14.1501 128.482 14.4093 127.872 14.8863C127.262 15.3633 126.828 16.0307 126.641 16.7823L124.904 23.7279C124.777 24.2397 124.767 24.7739 124.877 25.2899C124.986 25.8059 125.212 26.2902 125.537 26.7059C125.862 27.1217 126.277 27.458 126.751 27.6893C127.225 27.9207 127.745 28.041 128.273 28.0411H131.93L133.76 39.0326",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.291 61.3592L120.876 57.5947C120.626 57.4831 120.353 57.4321 120.08 57.446C119.807 57.4599 119.54 57.5382 119.303 57.6746L115.577 59.8173C115.318 59.9656 115.102 60.1779 114.949 60.4339C114.797 60.6898 114.713 60.9808 114.705 61.2787C114.697 61.5766 114.766 61.8715 114.906 62.135C115.045 62.3985 115.25 62.6217 115.5 62.7831L128.2 70.9789C128.432 71.1282 128.696 71.2202 128.97 71.2473C129.244 71.2745 129.521 71.2361 129.777 71.1352L144.71 65.2314L139.671 78.317C139.543 78.647 139.518 79.0084 139.601 79.3527C139.684 79.6969 139.871 80.0076 140.135 80.243C140.4 80.4784 140.73 80.6274 141.081 80.6698C141.433 80.7123 141.789 80.6462 142.102 80.4805L145.46 78.7441C145.764 78.5886 146.015 78.347 146.183 78.0495L155.559 60.9355L167.547 55.6395C168.633 55.184 169.493 54.316 169.938 53.2265C170.384 52.1369 170.378 50.9149 169.923 49.8295C169.467 48.744 168.599 47.884 167.51 47.4385C166.42 46.993 165.198 46.9986 164.113 47.4541L129.291 61.3592Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.343 52.5558L138.052 44.2211C137.795 44.0574 137.499 43.9645 137.194 43.9517C136.889 43.9389 136.586 44.0067 136.316 44.1481L132.753 45.9887C132.484 46.1272 132.255 46.3336 132.091 46.5875C131.926 46.8413 131.83 47.1339 131.813 47.4361C131.797 47.7382 131.859 48.0396 131.995 48.3102C132.13 48.5808 132.334 48.8113 132.586 48.9788L142.966 55.8828",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.43 54.3096C106.599 53.3284 102.147 50.9967 98.5887 47.5854C95.0308 44.1741 92.5139 39.8233 91.3305 35.0384C90.147 30.2536 90.3456 25.2311 91.9031 20.5546C93.4606 15.8781 96.3132 11.7396 100.129 8.61982C103.945 5.50006 108.568 3.52718 113.461 2.9304C118.354 2.33361 123.316 3.13742 127.77 5.24844C132.224 7.35946 135.988 10.691 138.623 14.856C141.259 19.021 142.659 23.8485 142.661 28.7775",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.39 49.1317L102.724 37.4596H105.224C105.752 37.4595 106.272 37.3391 106.747 37.1078C107.221 36.8764 107.636 36.5401 107.96 36.1244C108.285 35.7086 108.511 35.2244 108.62 34.7084C108.73 34.1924 108.721 33.6582 108.593 33.1464L106.857 26.2007C106.669 25.4491 106.236 24.7818 105.625 24.3048C105.015 23.8278 104.263 23.5686 103.488 23.5684H91.0935",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.39 49.1317L102.724 37.4596H105.224C105.752 37.4595 106.272 37.3391 106.747 37.1078C107.221 36.8764 107.636 36.5401 107.96 36.1244C108.285 35.7086 108.511 35.2244 108.62 34.7084C108.73 34.1924 108.721 33.6582 108.593 33.1464L106.857 26.2007C106.669 25.4491 106.236 24.7818 105.625 24.3048C105.015 23.8278 104.263 23.5686 103.488 23.5684H91.0935",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.417 13.1499H128.009C127.235 13.1501 126.482 13.4093 125.872 13.8863C125.262 14.3633 124.828 15.0307 124.641 15.7823L122.904 22.7279C122.777 23.2397 122.767 23.7739 122.877 24.2899C122.986 24.8059 123.212 25.2902 123.537 25.7059C123.862 26.1217 124.277 26.458 124.751 26.6893C125.225 26.9207 125.745 27.041 126.273 27.0411H129.93L131.76 38.0326",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.417 13.1499H128.009C127.235 13.1501 126.482 13.4093 125.872 13.8863C125.262 14.3633 124.828 15.0307 124.641 15.7823L122.904 22.7279C122.777 23.2397 122.767 23.7739 122.877 24.2899C122.986 24.8059 123.212 25.2902 123.537 25.7059C123.862 26.1217 124.277 26.458 124.751 26.6893C125.225 26.9207 125.745 27.041 126.273 27.0411H129.93L131.76 38.0326",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1678,
    cy: 52.6497,
    r: 49.9178,
    fill: "var(--error-background-color, #FEEDEB)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0354,
    y: 94.4946,
    width: 47.3033,
    height: 14,
    rx: 7,
    fill: "var(--primary-text-color, #313639)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4474 52.6498C93.4474 76.5525 74.0704 95.9295 50.1677 95.9295C26.265 95.9295 6.888 76.5525 6.888 52.6498C6.888 28.7471 26.265 9.37012 50.1677 9.37012C74.0704 9.37012 93.4474 28.7471 93.4474 52.6498Z",
    fill: "var(--error-color, #F44336)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6946 30.1373C73.714 26.6597 78.5236 34.5274 78.9872 36.1169",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8746 57.6213C58.6404 56.8355 55.9722 59.1114 55.7289 59.714",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1698 24.6705C37.1504 21.1929 32.3408 29.0606 31.8772 30.6501",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4053 39.7256C41.5726 39.7256 41.7361 39.7752 41.8751 39.8681C42.0141 39.961 42.1225 40.093 42.1865 40.2475C42.2505 40.402 42.2673 40.5721 42.2346 40.7361C42.202 40.9001 42.1215 41.0508 42.0032 41.169C41.885 41.2873 41.7343 41.3678 41.5703 41.4004C41.4063 41.433 41.2363 41.4163 41.0818 41.3523C40.9273 41.2883 40.7952 41.1799 40.7023 41.0409C40.6094 40.9018 40.5598 40.7384 40.5598 40.5711C40.5598 40.3469 40.6489 40.1318 40.8075 39.9732C40.966 39.8147 41.1811 39.7256 41.4053 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1762 39.7256C70.3434 39.7256 70.5069 39.7752 70.6459 39.8681C70.785 39.961 70.8933 40.093 70.9573 40.2475C71.0213 40.402 71.0381 40.5721 71.0054 40.7361C70.9728 40.9001 70.8923 41.0508 70.774 41.169C70.6558 41.2873 70.5051 41.3678 70.3411 41.4004C70.1771 41.433 70.0071 41.4163 69.8526 41.3523C69.6981 41.2883 69.566 41.1799 69.4731 41.0409C69.3802 40.9018 69.3306 40.7384 69.3306 40.5711C69.3306 40.3469 69.4197 40.1318 69.5783 39.9732C69.7368 39.8147 69.9519 39.7256 70.1762 39.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3643 79.5401L54.9173 73.6855L60.4292 72.8597C60.9719 72.8296 61.4804 72.5852 61.8429 72.1802C62.2054 71.7752 62.3922 71.2427 62.3621 70.7C62.3321 70.1573 62.0876 69.6488 61.6826 69.2863C61.2776 68.9238 60.7452 68.737 60.2024 68.7671L44.3632 69.2836C44.3632 69.2836 45.1876 60.7907 42.4216 60.7907C39.6555 60.7906 39.6814 63.9381 38.6113 69.36L28.0029 78.1988",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.092,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3386,
    y: 45.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutNotPossible);
export default __webpack_public_path__ + "static/media/checkout_not_possible.9f96d19c.svg";
export { ForwardRef as ReactComponent };